import { Column } from '@tanstack/react-table';
import { Skeleton } from '../../Skeleton';
import { getColumnFlexStyle as getColumnStyle } from '../columnStyle';
import { TableCell, TableRow } from '../Table';

interface SkeletonRowProps<T = unknown> {
  columns: Column<T, unknown>[];
}

export function SkeletonRow<T = unknown>({ columns }: SkeletonRowProps<T>) {
  // Separate columns by pinning status
  const leftPinnedColumns = columns.filter(
    (col) => col.getIsPinned() === 'left'
  );
  const centerColumns = columns.filter((col) => !col.getIsPinned());
  const rightPinnedColumns = columns.filter(
    (col) => col.getIsPinned() === 'right'
  );

  const renderCell = (
    column: Column<T, unknown>,
    isPinned?: 'left' | 'right'
  ) => (
    <TableCell
      key={column.id}
      className={`h-12 ${isPinned ? 'bg-white' : ''}`}
      style={getColumnStyle(
        column,
        isPinned
          ? {
              position: 'sticky',
              [isPinned]:
                isPinned === 'left'
                  ? column.getStart('left')
                  : column.getAfter('right'),
              zIndex: 1,
            }
          : undefined
      )}
    >
      {column.id === 'select' ? (
        <div className='flex items-center justify-center'>
          <Skeleton className='h-4 w-4' />
        </div>
      ) : column.id === 'actions' ? (
        <div className='flex items-center justify-center'>
          <Skeleton className='h-8 w-8 rounded-full' />
        </div>
      ) : column.id === 'status' ? (
        <Skeleton className='h-6 w-20' />
      ) : (
        <Skeleton className='h-4 w-full' />
      )}
    </TableCell>
  );

  return (
    <TableRow className='flex w-full'>
      {leftPinnedColumns.map((column) => renderCell(column, 'left'))}
      {centerColumns.map((column) => renderCell(column))}
      {rightPinnedColumns.map((column) => renderCell(column, 'right'))}
    </TableRow>
  );
}
